export const INIT_COMPANY_MARKUP = "INIT_COMPANY_MARKUP";
export const FETCH_CUSTOMERMARKUP_LIST_ERROR ='FETCH_CUSTOMERMARKUP_LIST_ERROR';
export const FETCH_CUSTOMERMARKUP_LIST_START ='FETCH_CUSTOMERMARKUP_LIST_START';
export const FETCH_CUSTOMERMARKUP_LIST_SUCCESS ='FETCH_CUSTOMERMARKUP_LIST_SUCCESS';

export const ADD_CUSTOMERMARKUP_RECORD = {
    START: 'ADD_CUSTOMERMARKUP_RECORD_START',
    SUCCESS: 'ADD_CUSTOMERMARKUP_RECORD_SUCCESS',
    ERROR: 'ADD_CUSTOMERMARKUP_RECORD_ERROR',
};

export const EDIT_CUSTOMERMARKUP_RECORD={
    START:"EDIT_CUSTOMERMARKUP_RECORD_START",
    SUCCESS:"EDIT_CUSTOMERMARKUP_RECORD_SUCCESS",
    ERROR:"EDIT_CUSTOMERMARKUP_RECORD_ERROR"
}
export const FUEL_COMPANY_PROVIDER_DD ={
    START:"FUEL_COMPANY_PROVIDER_DD_START",
    SUCCESS:"FUEL_COMPANY_PROVIDER_DD_SUCCESS",
    ERROR:"FUEL_COMPANY_PROVIDER_DD_ERROR"
}
export const FUEL_CUSTOMER_COMPANY_NAME_PROVIDER_DD ={
    START:"FUEL_CUSTOMER_COMPANY_NAME_PROVIDER_DD_START",
    SUCCESS:"FUEL_CUSTOMER_COMPANY_NAME_PROVIDER_DD_SUCCESS",
    ERROR:"FUEL_CUSTOMER_COMPANY_NAME_PROVIDER_DD_ERROR"
}